module.exports = __webpack_public_path__ + "static/logo-fb3190ed27014bce4ad56e05e14ed7e1.png";